"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("../state/state"));
var renderSizeInfo = function () {
    var $sizeInfo = document.querySelector('.list-static__size > span');
    $sizeInfo.textContent = state_1.default.sizeState.name;
};
exports.default = renderSizeInfo;
